//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'noauth',
  data () {
    return {
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/errorPage/noAuth.vue